/*
  DUK 1.3 Warenkorb-Drawer (sections/cart-drawer.liquid), Entwurf 14b–14e, Matthias 06.10.2026

  - Reiter „Warenkorb“ und „Gemerkt“ im Kopf des Drawers. Der gewählte Reiter bleibt während des Besuchs gewählt,
    auch wenn der Drawer nach einer Änderung neu geladen wird (Theme-Ereignis „cart-drawer:refreshed“). Legt man auf
    einer Produktseite etwas in den Warenkorb, springt er auf „Warenkorb“; legt man aus „Gemerkt“ etwas hinein,
    bleibt er dort.
  - <duk-cart-suggest>: ein Slider „Vorschläge“ aus drei Quellen (Matthias, 06.10.):
    1. „Passt dazu“: Ergänzungen (Search & Discovery, intent=complementary) zu bis zu drei Produkten im Warenkorb.
    2. „Aus der Serie“: andere Produkte aus der Serie eines Produkts im Warenkorb (Collection mit
       custom.collection_type „series“, Daten aus snippets/duk-cart-series.liquid). Regeln (Matthias, 06.10.):
       - nie teurer als das Produkt dieser Serie im Warenkorb: zur großen Kerze die kleine, zur kleinen nie die große;
       - Reihenfolge: passendes Refill (nur wenn das Produkt dazu im Warenkorb liegt), dann andere Produktarten,
         dann dieselbe Art kleiner; innerhalb davon die günstigsten zuerst; höchstens 4 je Serie;
       - keine zweite Konzentration desselben Parfums (Eau de Parfum, Eau de Toilette, Extrait, Cologne …); andere Düfte
         der Serie in derselben Konzentration schon.
    3. „Für den Gratisversand“: nur unter der Schwelle und nur für Produkte, die die Lücke schließen und höchstens
       10 € darüber liegen (Matthias, 06.10.: ein 38-€-Produkt für eine 10-€-Lücke ist zu viel). Zuerst solche aus
       1 und 2, dann Auffüller aus der Collection in der Drawer-Einstellung (Seifen: passen fast jedem), günstigste
       zuerst, je Marke eine, höchstens 4. Marken aus „Auffüller: Marken ausschließen“ kommen nicht als Auffüller
       (Matthias 06.10.: Tadé, Lagerstand oft falsch; Castelbel, saisonal). Wer Düfte kauft, bekommt vor den Seifen
       das Discovery Set derselben Marke, wenn es in die Spanne passt (Einstellung „Auffüller für Duftkäufe“).
       Auffüller nur bei Lücken bis 30 €, die höchstens halb so groß sind wie der Warenkorb (Matthias, 06.10.).
    Jede Karte nennt genau einen Grund (immer entweder oder). Gibt es nichts davon, bleibt der Slider weg; über der
    Schwelle kommt nichts aus der Ersatz-Collection („Tipp“ ohne Bezug zum Einkauf, Matthias 06.10.: zu aufdringlich).
    Geladen wird erst, wenn der Warenkorb aufgeht (nicht auf jeder Seite im Hintergrund).
    Karten: sections/duk-cart-suggestions.liquid (Section Rendering).
    Leerer Warenkorb (data-empty): Vorschläge aus einer Collection, sonst Team Picks (Knis, Matthias 06.10.).
  - <duk-cart-saved>: Reiter „Gemerkt“ mit den eigenen Listen aus der Wunschliste (window.DukWishlist), ohne
    „Vor Ort probieren“ (die Liste ist fürs Geschäft, Matthias 06.10.). Zeilen: sections/duk-cart-saved-row.liquid.
  - Länderwechsel: der Warenkorb reist mit (.at und .com haben je einen eigenen), siehe unten.
*/

const SUGGEST_SECTION = 'duk-cart-suggestions';
const SAVED_SECTION = 'duk-cart-saved-row';
const TAB_KEY = 'duk:cart:tab';
const LIST_KEY = 'duk:cart:list';
const TRY = 'try';
const MAIN = 'main';
const MAX_SUGGESTIONS = 10;
// Auffüller aus der Ersatz-Kollektion höchstens so viele, damit die Ergänzungen sichtbar bleiben; je Marke einer
const MAX_FILLERS = 4;
// Aus einer Serie höchstens so viele, damit eine große Serie die anderen nicht verdrängt
const MAX_PER_SERIES = 4;
const MAX_SERIES = 3;
// Konzentrationen desselben Parfums: zum Eau de Parfum nicht das Eau de Toilette derselben Serie vorschlagen
const PERFUME_TYPES = new Set(['eau de parfum', 'eau de toilette', 'eau de cologne', 'extrait de parfum', 'eau fraîche', 'parfum']);
const kindOf = (type) => (PERFUME_TYPES.has(type) ? 'parfum' : type);
// Düfte im Warenkorb erkennen (für das passende Discovery Set als Auffüller)
const isFragranceType = (type) => /parfum|toilette|cologne|fraîche|extrait/.test(type) && !/haar/.test(type);
// Titel vergleichbar machen: ohne weiche Trennstriche, Leerzeichen zusammengefasst, klein
const SOFT_HYPHEN = new RegExp(String.fromCharCode(0xad), 'g');
const normTitle = (text) => String(text || '').replace(SOFT_HYPHEN, '').replace(/\s+/g, ' ').trim().toLowerCase();
const MAX_SAVED = 30;

const de = (document.documentElement.lang || '').toLowerCase().startsWith('de');
const T = de
  ? {
      gratis: 'Für den Gratisversand',
      passt: 'Passt dazu',
      serie: 'Aus der Serie',
      main: 'Wunschliste',
      unnamed: 'Liste',
      loading: 'Wird geladen …',
      empty: 'Noch nichts gemerkt. Tippe bei einem Produkt auf das Herz, dann findest du es hier.',
      emptyList: 'In dieser Liste ist noch nichts.',
      all: 'Alle Listen ansehen',
      inCart: 'Im Warenkorb',
      carriedMissing: 'Nicht alles aus deinem Warenkorb ist hier verfügbar: {n} Produkt(e) fehlen.'
    }
  : {
      gratis: 'For free shipping',
      passt: 'Pairs well',
      serie: 'From the same line',
      main: 'Wishlist',
      unnamed: 'List',
      loading: 'Loading …',
      empty: 'Nothing saved yet. Tap the heart on any product to find it here.',
      emptyList: 'Nothing in this list yet.',
      all: 'See all lists',
      inCart: 'In your cart',
      carriedMissing: 'Not everything from your cart is available here: {n} product(s) missing.'
    };

const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function sessionGet(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function sessionSet(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    /* private mode: the choice lives for this page only */
  }
}

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);

/* ---------------------------------------------------------------------------------------------- */
/* Reiter                                                                                          */
/* ---------------------------------------------------------------------------------------------- */

let activeTab = sessionGet(TAB_KEY) === 'saved' ? 'saved' : 'cart';
let stayOnSaved = false;

const wishlistReady = () => Boolean(window.DukWishlist);

function savedLists() {
  if (!wishlistReady()) return [];
  return window.DukWishlist.lists.filter((list) => list.id !== TRY);
}

function savedTotal() {
  return savedLists().reduce((sum, list) => sum + list.items.length, 0);
}

function setTab(tab) {
  activeTab = tab === 'saved' && wishlistReady() ? 'saved' : 'cart';
  sessionSet(TAB_KEY, activeTab);
  applyTabs();
}

function applyTabs() {
  document.querySelectorAll('cart-drawer.drawer--duk').forEach((drawer) => {
    const savedTab = drawer.querySelector('[data-duk-cart-tab="saved"]');
    if (savedTab) {
      savedTab.hidden = !wishlistReady();
      const count = savedTab.querySelector('[data-duk-saved-count]');
      const total = savedTotal();
      if (count) count.textContent = total > 0 ? ` (${total})` : '';
    }

    const tab = activeTab === 'saved' && wishlistReady() ? 'saved' : 'cart';

    drawer.querySelectorAll('[data-duk-cart-tab]').forEach((button) => {
      button.setAttribute('aria-selected', String(button.dataset.dukCartTab === tab));
      button.tabIndex = button.dataset.dukCartTab === tab ? 0 : -1;
    });

    drawer.querySelectorAll('[data-duk-cart-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.dukCartPanel !== tab;
    });

    if (tab === 'saved') drawer.querySelector('duk-cart-saved')?.render();
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-duk-cart-tab]');
  if (button) {
    setTab(button.dataset.dukCartTab);
    return;
  }

  // Aus „Gemerkt“ in den Warenkorb: nach dem Neuladen des Drawers auf „Gemerkt“ bleiben
  if (event.target.closest('[data-duk-saved-add]')) stayOnSaved = true;
});

document.addEventListener('keydown', (event) => {
  const button = event.target.closest && event.target.closest('[data-duk-cart-tab]');
  if (!button || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

  const tabs = Array.from(button.parentElement.querySelectorAll('[data-duk-cart-tab]:not([hidden])'));
  const next = tabs[(tabs.indexOf(button) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
  if (next) {
    setTab(next.dataset.dukCartTab);
    next.focus();
  }
});

// Etwas auf einer Produktseite in den Warenkorb gelegt: der Drawer zeigt den Warenkorb
document.addEventListener('cart:change', (event) => {
  if (event.detail && event.detail.baseEvent === 'variant:add') {
    if (stayOnSaved) {
      stayOnSaved = false;
    } else {
      activeTab = 'cart';
      sessionSet(TAB_KEY, 'cart');
    }
  }
});

document.addEventListener('cart-drawer:refreshed', applyTabs);
document.addEventListener('duk-wishlist:change', applyTabs);
window.addEventListener('load', applyTabs);
applyTabs();

/* ---------------------------------------------------------------------------------------------- */
/* Vorschläge                                                                                      */
/* ---------------------------------------------------------------------------------------------- */

const cardCache = new Map();
const suggestRenders = new Map();

function fetchCards(url) {
  if (!cardCache.has(url)) {
    const request = fetch(url, { headers: { Accept: 'text/html' } })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('.duk-cart-sugg')).map((card) => ({
          id: card.dataset.productId,
          price: Number(card.dataset.price) || 0,
          type: (card.dataset.type || '').trim().toLowerCase(),
          title: normTitle(card.dataset.title),
          vendor: String(card.dataset.vendor || '').normalize('NFC').trim().toLowerCase(),
          refill: card.hasAttribute('data-refill'),
          html: card.outerHTML
        }));
      })
      .catch(() => {
        cardCache.delete(url);
        return [];
      });
    cardCache.set(url, request);
  }

  return cardCache.get(url);
}

class DukCartSuggest extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-duk-suggest-track]');
    if (!this.track) return;

    const key = ['empty', 'products', 'exclude', 'gap', 'fallback', 'fallbackExclude', 'fallbackPerfume', 'series'].map((name) => this.dataset[name] || '').join('|');

    // Gleicher Warenkorb wie eben: sofort zeigen, ohne Flackern
    if (suggestRenders.has(key)) {
      this.show(suggestRenders.get(key));
      return;
    }

    // Erst laden, wenn der Warenkorb aufgeht: sonst liefen die Abfragen auf jeder Seite mit, auch ungeöffnet
    this.drawer = this.closest('cart-drawer');
    if (!this.drawer || this.drawer.hasAttribute('open')) {
      this.load(key);
      return;
    }
    this.onShow = () => this.load(key);
    this.drawer.addEventListener('dialog:before-show', this.onShow, { once: true });
  }

  disconnectedCallback() {
    if (this.drawer && this.onShow) this.drawer.removeEventListener('dialog:before-show', this.onShow);
  }

  show(html) {
    this.track.innerHTML = html;
    this.hidden = html === '';
  }

  async load(key) {
    if (this.dataset.empty) {
      await this.loadEmpty(key);
      return;
    }

    const ids = (this.dataset.products || '').split(',').filter(Boolean);
    const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
    const gap = Number(this.dataset.gap) || 0;
    const margin = Number(this.dataset.margin) || 1000;
    // Auffüller (Discovery Set, Seifen) nur bei kleinen Lücken: höchstens 30 € und höchstens halb so viel wie der Warenkorb.
    // Wer für 68 € nach Deutschland bestellt, legt für den Gratisversand keine 57 € nach (Matthias, 06.10.)
    const total = Number(this.dataset.total) || 0;
    const maxGap = Number(this.dataset.maxGap) || 3000;
    const fillGap = gap > 0 && gap <= maxGap && gap * 2 <= total;
    const fallbackHandle = this.dataset.fallback || '';
    const perfumeHandle = this.dataset.fallbackPerfume || '';
    const vendorKey = (name) => String(name || '').normalize('NFC').trim().toLowerCase();
    const blockedVendors = new Set((this.dataset.fallbackExclude || '').split(',').map(vendorKey).filter(Boolean));
    const byPrice = (a, b) => a.price - b.price;

    // Produkte im Warenkorb: je Serie der höchste Stückpreis und die Produktarten, die schon drinliegen;
    // dazu alle Titel (Refill nur zum passenden Produkt) und die Marken der Düfte (passendes Discovery Set)
    const series = new Map();
    const cartTitles = new Set();
    const fragranceVendors = new Set();
    try {
      JSON.parse(this.dataset.series || '[]').forEach((entry) => {
        if (!entry) return;
        const type = String(entry.t || '').trim().toLowerCase();
        if (entry.n) cartTitles.add(normTitle(entry.n));
        if (entry.v && isFragranceType(type)) fragranceVendors.add(vendorKey(entry.v));
        if (!entry.h) return;
        const current = series.get(entry.h) || { max: 0, kinds: new Set(), types: new Set() };
        current.max = Math.max(current.max, Number(entry.p) || 0);
        if (type) {
          current.kinds.add(kindOf(type));
          current.types.add(type);
        }
        series.set(entry.h, current);
      });
    } catch (error) {
      /* ohne Serien */
    }
    const seriesHandles = Array.from(series.keys()).slice(0, MAX_SERIES);
    const collectionUrl = (handle) => `${root()}collections/${encodeURIComponent(handle)}?section_id=${SUGGEST_SECTION}`;

    const [lists, seriesLists] = await Promise.all([
      Promise.all(
        ids.map((id) => fetchCards(`${root()}recommendations/products?product_id=${encodeURIComponent(id)}&limit=10&intent=complementary&section_id=${SUGGEST_SECTION}`))
      ),
      Promise.all(seriesHandles.map((handle) => fetchCards(collectionUrl(handle))))
    ]);

    // 1. Passt dazu: abwechselnd aus den Ergänzungen der einzelnen Produkte, ohne Doppelte und ohne, was schon im Warenkorb liegt
    const seen = new Set();
    const recs = [];
    const longest = Math.max(0, ...lists.map((list) => list.length));
    for (let index = 0; index < longest; index += 1) {
      lists.forEach((list) => {
        const card = list[index];
        if (card && !seen.has(card.id) && !exclude.has(card.id)) {
          seen.add(card.id);
          recs.push({ ...card, source: 'recs' });
        }
      });
    }

    // 2. Aus der Serie: nie teurer als das Produkt dieser Serie im Warenkorb (zur großen Kerze die kleine, nie umgekehrt),
    //    keine zweite Konzentration desselben Parfums, Refills nur zum passenden Produkt im Warenkorb.
    //    Reihenfolge: passendes Refill, andere Produktarten, dieselbe Art kleiner; jeweils günstigste zuerst
    const fromSeries = [];
    const refillFits = (card) => cartTitles.has(card.title.replace(/\s*refill\s*$/, ''));
    seriesHandles.forEach((handle, index) => {
      const { max, kinds, types } = series.get(handle);
      // Eine andere Konzentration desselben Dufts nicht (zum Eau de Parfum kein Eau de Toilette); andere Düfte der Serie
      // in derselben Art schon (Trudon Nuit Rouge: zum Travel Size 45° der Travel Size Mystique, Matthias 06.10.)
      const otherConcentration = (card) => kindOf(card.type) === 'parfum' && kinds.has('parfum') && !types.has(card.type);
      const rank = (card) => (card.refill ? 0 : kinds.has(kindOf(card.type)) ? 2 : 1);
      seriesLists[index]
        .filter((card) => !seen.has(card.id) && !exclude.has(card.id) && card.price > 0 && card.price <= max)
        .filter((card) => (card.refill ? refillFits(card) : !otherConcentration(card)))
        .sort((a, b) => rank(a) - rank(b) || byPrice(a, b))
        .slice(0, MAX_PER_SERIES)
        .forEach((card) => {
          seen.add(card.id);
          fromSeries.push({ ...card, source: 'series' });
        });
    });

    // „Für den Gratisversand“ nur, wenn die Karte die Lücke schließt und höchstens 10 € darüber liegt
    const closesGap = (card) => gap > 0 && card.price >= gap && card.price <= gap + margin;
    const ownReason = (card) => (card.source === 'series' ? 'serie' : 'passt');

    // 3. Auffüller nur unter der Schwelle, günstigste zuerst, je Marke einer, höchstens 4:
    //    erst das Discovery Set einer Duft-Marke im Warenkorb, dann die Ersatz-Collection (Seifen)
    let fillers = [];
    if (fillGap && (fallbackHandle || (perfumeHandle && fragranceVendors.size))) {
      const [setCards, cards] = await Promise.all([
        perfumeHandle && fragranceVendors.size ? fetchCards(`${collectionUrl(perfumeHandle)}&sort_by=price-ascending`) : [],
        fallbackHandle ? fetchCards(`${collectionUrl(fallbackHandle)}&sort_by=price-ascending`) : []
      ]);
      // je Marke einer, auch gegenüber den passenden Produkten davor (nicht zweimal Diptyque)
      const vendors = new Set([...recs, ...fromSeries].filter(closesGap).map((card) => card.vendor));
      const usable = (card) => !seen.has(card.id) && !exclude.has(card.id) && !blockedVendors.has(card.vendor) && closesGap(card);
      const oncePerVendor = (card) => {
        if (card.vendor && vendors.has(card.vendor)) return false;
        vendors.add(card.vendor);
        seen.add(card.id);
        return true;
      };
      const sets = setCards.filter((card) => usable(card) && fragranceVendors.has(card.vendor)).sort(byPrice).filter(oncePerVendor);
      const soaps = cards.filter(usable).sort(byPrice).filter(oncePerVendor);
      fillers = [...sets, ...soaps].slice(0, MAX_FILLERS).map((card) => ({ ...card, source: 'fallback' }));
    }

    let items;

    if (gap > 0) {
      const related = [...recs, ...fromSeries];
      items = [
        ...related.filter(closesGap).sort(byPrice),
        ...fillers,
        ...recs.filter((card) => !closesGap(card)),
        ...fromSeries.filter((card) => !closesGap(card))
      ].map((card) => ({ ...card, reason: closesGap(card) ? 'gratis' : ownReason(card) }));
    } else {
      items = [...recs, ...fromSeries].map((card) => ({ ...card, reason: ownReason(card) }));
    }

    // Je Karte genau ein Grund. Über das DOM statt per Textersatz: DOMParser schreibt Attribute als hidden=""
    const html = items
      .slice(0, MAX_SUGGESTIONS)
      .map((card) => {
        if (!card.reason) return card.html;
        const template = document.createElement('template');
        template.innerHTML = card.html;
        const reason = template.content.querySelector('[data-reason]');
        if (reason) {
          reason.textContent = T[card.reason];
          reason.hidden = false;
        }
        return template.innerHTML;
      })
      .join('');

    suggestRenders.set(key, html);
    if (this.isConnected) this.show(html);
  }

  // Leerer Warenkorb (Knis, Matthias 06.10.): Vorschläge aus einer Collection (Einstellung, sonst Team Picks) in deren
  // Reihenfolge, je Marke eines, ohne ausgeschlossene Marken, höchstens 10. Ohne Grund-Zeile: es gibt keinen Einkauf, auf
  // den sie sich beziehen könnte.
  async loadEmpty(key) {
    const vendorKey = (name) => String(name || '').normalize('NFC').trim().toLowerCase();
    const blockedVendors = new Set((this.dataset.fallbackExclude || '').split(',').map(vendorKey).filter(Boolean));
    const cards = await fetchCards(`${root()}collections/${encodeURIComponent(this.dataset.empty)}?section_id=${SUGGEST_SECTION}`);
    const vendors = new Set();

    const html = cards
      .filter((card) => card.price > 0 && !blockedVendors.has(card.vendor))
      .filter((card) => {
        if (card.vendor && vendors.has(card.vendor)) return false;
        vendors.add(card.vendor);
        return true;
      })
      .slice(0, MAX_SUGGESTIONS)
      .map((card) => card.html)
      .join('');

    suggestRenders.set(key, html);
    if (this.isConnected) this.show(html);
  }
}

if (!window.customElements.get('duk-cart-suggest')) window.customElements.define('duk-cart-suggest', DukCartSuggest);

/* ---------------------------------------------------------------------------------------------- */
/* Gemerkt                                                                                         */
/* ---------------------------------------------------------------------------------------------- */

const rowCache = new Map();

// Eine Zeile je Produkt. Gelöschte Produkte (404) bleiben leer; eine fehlgeschlagene Anfrage wird nicht gemerkt, sonst
// stünde „Gemerkt (1)“ ohne Zeile da, bis man die Seite neu lädt (Matthias, 06.10.). null = später noch einmal versuchen.
function fetchRow(handle) {
  if (!rowCache.has(handle)) {
    const request = fetch(`${root()}products/${encodeURIComponent(handle)}?section_id=${SAVED_SECTION}`, { headers: { Accept: 'text/html' } })
      .then(async (response) => {
        if (response.status === 404) return '';
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const row = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.duk-cart-saved');
        return row ? row.outerHTML : '';
      })
      .catch(() => {
        rowCache.delete(handle);
        return null;
      });
    rowCache.set(handle, request);
  }

  return rowCache.get(handle);
}

function listName(list) {
  if (list.id === MAIN) return T.main;
  return list.name || T.unnamed;
}

class DukCartSaved extends HTMLElement {
  connectedCallback() {
    this.onChange = () => {
      if (!this.closest('[data-duk-cart-panel]')?.hidden) this.render();
    };
    document.addEventListener('duk-wishlist:change', this.onChange);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    document.removeEventListener('duk-wishlist:change', this.onChange);
  }

  onClick = (event) => {
    const chip = event.target.closest('[data-duk-saved-list]');
    if (chip) {
      sessionSet(LIST_KEY, chip.dataset.dukSavedList);
      this.render();
      return;
    }

    const remove = event.target.closest('[data-duk-saved-remove]');
    if (remove && window.DukWishlist) {
      const row = remove.closest('[data-handle]');
      if (row) window.DukWishlist.remove(row.dataset.handle, this.currentList);
    }
  };

  async render() {
    if (!wishlistReady()) return;

    const lists = savedLists();
    const shown = lists.filter((list) => list.id === MAIN || list.items.length > 0);
    const stored = sessionGet(LIST_KEY);
    const current = shown.find((list) => list.id === stored) || shown.find((list) => list.items.length > 0) || shown[0];
    const pageUrl = this.dataset.pageUrl || '/pages/wunschliste';
    const total = lists.reduce((sum, list) => sum + list.items.length, 0);
    const token = (this.token = Symbol('render'));

    this.currentList = current ? current.id : MAIN;

    if (total === 0 || !current) {
      this.innerHTML = `
        <div class="duk-cart-saved">
          <p class="duk-cart-saved__empty">${escapeHtml(T.empty)}</p>
          <a class="duk-cart-saved__all" href="${escapeHtml(pageUrl)}">${escapeHtml(T.all)}</a>
        </div>`;
      return;
    }

    // Listen nur mit Namen, ohne Anzahl: „Wunschliste 4“ läse sich wie ein Name (Matthias, 06.10.)
    const chips = shown.length > 1
      ? `<div class="duk-cart-saved__lists">${shown
          .map((list) => `<button type="button" class="duk-cart-saved__chip" data-duk-saved-list="${escapeHtml(list.id)}" aria-pressed="${list.id === current.id}">${escapeHtml(listName(list))}</button>`)
          .join('')}</div>`
      : '';

    const items = current.items.slice(0, MAX_SAVED);

    this.innerHTML = `
      <div class="duk-cart-saved">
        ${chips}
        <div class="duk-cart-saved__rows" data-rows>${items.length === 0 ? `<p class="duk-cart-saved__empty">${escapeHtml(T.emptyList)}</p>` : `<p class="duk-cart-saved__status">${escapeHtml(T.loading)}</p>`}</div>
        <a class="duk-cart-saved__all" href="${escapeHtml(pageUrl)}">${escapeHtml(T.all)}</a>
      </div>`;

    if (items.length === 0) return;

    const rows = await Promise.all(items.map((item) => fetchRow(item.handle)));
    if (token !== this.token || !this.isConnected) return;

    // Ist eine Zeile nicht gekommen, gleich noch einmal versuchen (höchstens zweimal)
    if (rows.includes(null) && (this.retries || 0) < 2) {
      this.retries = (this.retries || 0) + 1;
      window.setTimeout(() => {
        if (this.isConnected && !this.closest('[data-duk-cart-panel]')?.hidden) this.render();
      }, 800 * this.retries);
    } else if (!rows.includes(null)) {
      this.retries = 0;
    }

    const inCart = new Set((this.dataset.inCart || '').split(',').filter(Boolean));
    const container = this.querySelector('[data-rows]');
    container.innerHTML = rows.filter(Boolean).join('');

    // Was schon im Warenkorb liegt: Häkchen statt „+“
    container.querySelectorAll('.duk-cart-saved[data-product-id]').forEach((row) => {
      if (!inCart.has(row.dataset.productId)) return;
      const form = row.querySelector('product-form');
      if (form) {
        form.outerHTML = `<span class="duk-circle duk-circle--outline duk-cart-line__remove" title="${escapeHtml(T.inCart)}"><svg aria-hidden="true" width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8.5l3.2 3L13 4.5"/></svg><span class="sr-only">${escapeHtml(T.inCart)}</span></span>`;
      }
    });

    if (!container.children.length) container.innerHTML = `<p class="duk-cart-saved__empty">${escapeHtml(T.emptyList)}</p>`;
  }
}

if (!window.customElements.get('duk-cart-saved')) window.customElements.define('duk-cart-saved', DukCartSaved);

/* ---------------------------------------------------------------------------------------------- */
/* Länderwechsel: der Warenkorb reist mit (Matthias, 06.10.)                                        */
/* ---------------------------------------------------------------------------------------------- */

// Österreich liegt auf .at, Deutschland auf .com, und jede Domain hat ihren eigenen Warenkorb: Shopify nimmt ihn beim
// Länderwechsel nicht mit (geprüft 06.10.). Alle Produkte gibt es in jedem Markt, nur Versand und Preise können anders
// sein, also geht so viel wie möglich mit (Matthias, 06.10.): Produkte mit Menge und Eigenschaften (Geschenk, Name),
// Anmerkung, Warenkorb-Attribute und Rabattcodes. Sie hängen wie die Wunschliste an der Rücksprungadresse des
// Länderformulars (?wk=…) und ersetzen drüben den dortigen Warenkorb. Bleibt die Domain gleich (nur die Sprache
// gewechselt), ist es derselbe Warenkorb und es passiert nichts.
const CART_PARAM = 'wk';
const CART_MAX_LINES = 60;
const CARRY_TIMEOUT = 2500;

function toBase64Url(text) {
  let binary = '';
  new TextEncoder().encode(text).forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(value) {
  const binary = atob(value.replace(/-/g, '+').replace(/_/g, '/'));
  return new TextDecoder().decode(Uint8Array.from(binary, (char) => char.charCodeAt(0)));
}

const fetchCartJson = () => fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((response) => response.json());

const cleanProperties = (properties) => {
  const entries = Object.entries(properties || {}).filter(([, value]) => value !== null && value !== undefined && value !== '');
  return entries.length > 0 ? Object.fromEntries(entries) : null;
};

async function cartCarryValue() {
  const cart = await fetchCartJson();
  const payload = {
    t: String(cart.token || ''),
    i: (cart.items || []).slice(0, CART_MAX_LINES).map((item) => {
      const properties = cleanProperties(item.properties);
      return properties ? [item.variant_id, item.quantity, properties] : [item.variant_id, item.quantity];
    })
  };

  if (cart.note) payload.n = cart.note;
  const attributes = cleanProperties(cart.attributes);
  if (attributes) payload.a = attributes;
  const codes = (cart.discount_codes || []).filter((entry) => entry && entry.applicable).map((entry) => entry.code);
  if (codes.length > 0) payload.d = codes;

  return toBase64Url(JSON.stringify(payload));
}

// Vor dem Absenden den aktuellen Warenkorb holen, dann mit demselben Knopf (Land) noch einmal absenden. Klappt das
// nicht rechtzeitig, geht der Wechsel ohne Warenkorb weiter.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !/\/localization$/.test(form.getAttribute('action') || '')) return;

  if (form.dataset.dukCartCarried === '1') {
    delete form.dataset.dukCartCarried;
    return;
  }

  const input = form.querySelector('input[name="return_to"]');
  if (!input || typeof form.requestSubmit !== 'function') return;

  event.preventDefault();
  const submitter = event.submitter && event.submitter.form === form ? event.submitter : null;
  const timeout = new Promise((resolve) => { window.setTimeout(() => resolve(''), CARRY_TIMEOUT); });

  Promise.race([cartCarryValue().catch(() => ''), timeout]).then((value) => {
    try {
      const url = new URL(input.value || window.location.pathname, window.location.origin);
      url.searchParams.delete(CART_PARAM);
      if (value) url.searchParams.set(CART_PARAM, value);
      input.value = `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      /* ohne Warenkorb weiter */
    }

    form.dataset.dukCartCarried = '1';
    if (submitter) form.requestSubmit(submitter);
    else form.requestSubmit();
  });
}, true);

async function importCart() {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(CART_PARAM);
  if (!value) return;

  url.searchParams.delete(CART_PARAM);
  window.history.replaceState(window.history.state, '', url.toString());

  let data;
  try {
    data = JSON.parse(fromBase64Url(value));
  } catch (error) {
    return;
  }
  if (!data || typeof data !== 'object' || !Array.isArray(data.i)) return;

  const post = (path, body) => fetch(`${root()}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  });
  const refresh = () => document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  try {
    const current = await fetchCartJson();
    if (data.t && current.token === data.t) return;

    const items = data.i
      .filter((line) => Array.isArray(line) && Number(line[0]) > 0 && Number(line[1]) > 0)
      .slice(0, CART_MAX_LINES)
      .map(([id, quantity, properties]) => {
        const item = { id: Number(id), quantity: Number(quantity) };
        if (properties && typeof properties === 'object') item.properties = properties;
        return item;
      });

    await post('cart/clear.js', {});

    let missing = 0;
    if (items.length > 0) {
      const all = await post('cart/add.js', { items });
      // Einzeln nachlegen, damit ein nicht verfügbares Produkt nicht alle anderen mitnimmt
      if (!all.ok) {
        for (const item of items) {
          const one = await post('cart/add.js', { items: [item] });
          if (!one.ok) missing += 1;
        }
      }
    }

    // Anmerkung und Attribute wie drüben; alte Attribute dieses Warenkorbs fallen weg
    const attributes = {};
    Object.keys(current.attributes || {}).forEach((key) => { attributes[key] = ''; });
    Object.assign(attributes, data.a && typeof data.a === 'object' ? data.a : {});
    await post('cart/update.js', { note: typeof data.n === 'string' ? data.n : '', attributes });

    const codes = Array.isArray(data.d) ? data.d.filter((code) => typeof code === 'string' && code) : [];
    if (codes.length > 0 || (current.discount_codes || []).length > 0) {
      await post('cart/update.js', { discount: codes.join(',') });
    }

    refresh();
    if (missing > 0) {
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: escapeHtml(T.carriedMissing.replace('{n}', missing)), duration: 6000 } }));
    }
  } catch (error) {
    refresh();
  }
}

importCart();

// Anmerkung: Punkt am Knopf „Anmerkung“, sobald etwas eingetragen ist (Knis, 06.10.). Das Theme speichert die Anmerkung
// beim Verlassen des Felds (change), ohne den Drawer neu zu zeichnen; beim nächsten Zeichnen setzt ihn die Section selbst.
document.addEventListener('change', (event) => {
  const field = event.target;

  if (!(field instanceof HTMLTextAreaElement) || field.name !== 'note') return;

  const filled = field.value.trim() !== '';
  document.querySelectorAll('.duk-cart-links__note').forEach((button) => button.toggleAttribute('data-duk-note', filled));
});
